import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WhatsappInstanceService {

  constructor(private apiService: ApiService) { }

  getQR(queryParams: HttpParams){
    return this.apiService.get('whatsapp/qr', queryParams)
  }

  getStatus(queryParams: HttpParams){
    return this.apiService.get('whatsapp/instance/status', queryParams)
  }

  createInstance() {
    return this.apiService.post('whatsapp/create',"");
  }

  restartInstance() {
    return this.apiService.post('whatsapp/restart',"");
  }

  terminateInstance() {
    return this.apiService.post('whatsapp/terminate',"");
  }

  sendWhatsappMsg(data:any) {
    return this.apiService.post('whatsapp/send',data);
  }

  sendPDF() {
    return this.apiService.post('whatsapp/send-pdf',"");
  }
}
